<template>

  <article class="tes-article"
           itemscope itemtype="http://schema.org/Article">


    <meta  itemprop="mainEntityOfPage" itemscope itemtype="https://schema.org/WebPage"
          :itemid="`https://tion.ru/blog/${post.tid()}`" :content="post.header()">

    <head>
    <div itemprop="schema" itemscope itemtype="https://schema.org">
      <meta itemprop="schema" :content="post.schema()">
    </div>
    </head>

    <header class="tes-article__header">

      <h1 class="tes-article__header-title" itemprop="headline" v-html="post.header()"></h1>

      <ul class="tes-article__tags-container">
        <li :class="['tes-article__tag', `tes-article__tag_color-${number}`]" v-for="(tag, number) in post.tags()">
          <router-link :to="tag.path()" class="tes-article__tag-link">{{ tag.title() }}</router-link>
        </li>
      </ul>

      <div class="tes-article__metrics">
        <!-- span v-if="post.publishedAt()">{{ post.publishedAtLocaleDateString('ru') }}</span -->
        <span class="tes-article__metrics-item tes-article__metrics-item_comments">
          <a href="#comments"><span class="tes-article__metrics-icon-wrapper">
            <CommentBarsIcon class="tes-article__metrics-icon" style="max-width:24px;"/>
            <!-- font-awesome-icon icon="fa-solid fa-comment-dots" class="tes-article__metrics-icon" style="max-width:24px;"/ -->
          </span> <span itemprop="commentCount" title="количество комментарие">{{ post.countComments() }}</span></a>
        </span>
        <span class="tes-article__metrics-item tes-article__metrics-item_views">
          <span class="tes-article__metrics-icon-wrapper">
            <EyeIcon class="tes-article__metrics-icon" style="max-width:24px;"/>
            <!-- font-awesome-icon icon="fa-solid fa-eye" class="tes-article__metrics-icon" style="max-width:24px;" /-->
          </span> {{ post.countViews() }}
        </span>
        <span class="tes-article__metrics-item tes-article__metrics-item_age-rating">
          <span class="tes-article__metrics-icon-wrapper"
          ><Rating12PlusIcon class="tes-article__metrics-icon" style="max-width:28px;"/></span>
        </span>
      </div>

    </header>

    <figure itemprop="image" itemscope itemtype="https://schema.org/ImageObject"
            class="tes-picture__container tes-picture__container_loading">

      <LazyLoadPicture
        pictureClass="tes-picture__wrapper"
        imageClass="tes-article__picture-image tes-picture__image"
        :image="post.image()"
        :altEmpty="post.header()"
        imageItemprop="url contentUrl"
        :variants="post.imageVariants()"/>

      <meta itemprop="width" :content="post.image()?.size().width().toString()">
      <meta itemprop="height" :content="post.image()?.size().height().toString()">

    </figure>

    <div class="tes-article__introduction">
      <div
        :class="{
          'tes-article__introduction-icon-wrapper':true,
          'tes-article__introduction-icon-wrapper_style': post.icon() && post.icon().id() && post.icon().type() !== 'storage'
          }" v-if="post.icon().type() === 'storage'">
        <IconView class="tes-article__introduction-icon" iconClass="tes-article__introduction-icon-image"
                  :icon="post.icon()" v-if="post.icon() && post.icon().id()" />
        <!-- SmileSmartIcon class="tes-article__introduction-icon" v-else/ -->
      </div>
      <p class="tes-article__dates">
        <span class="tes-article__date-published">Опубликовано: {{ post.publishedAtLocaleDateString('ru') }}</span>
        <span class="tes-article__date-updated">Обновлено: {{ post.updatedAtLocaleDateString('ru') }}</span>
        <meta itemprop="datePublished" :content="post.publishedAtIso()">
        <meta itemprop="dateModified" :content="post.updatedAtIso()">
      </p>
      <div class="tes-article__introduction-content"
           itemprop="description"
           v-html="post.introduction()"></div>
    </div>

    <nav class="tes-article__theses" v-if="post.hasTheses()">
      <h2 class="tes-article__theses-list-header">Содержание:</h2>
      <ul class="tes-article__theses-list"
          itemprop="articleSection">
        <li class="tes-article__theses-list-item" v-for="thesis in post.theses()">
          <a :href="thesis.anchor()" class="tes-article__thesis-link"><span
            class="tes-article__thesis-link">{{ thesis.title() }}</span></a>
          <ul>
            <li class="tes-article__theses-list-item" v-for="subTheses in thesis.theses()">
              <a :href="subTheses.anchor()" class="tes-article__thesis-link"><span
                class="tes-article__thesis-link">{{ subTheses.title() }}</span></a>
            </li>
          </ul>
        </li>
      </ul>
    </nav>


    <div v-html="post.content()" ref="postContentEl" class="tes-article__body" itemprop="articleBody"></div>

    <div class="tes-article__footer" itemprop="author" itemscope itemtype="http://schema.org/Person">
      <p class="tes-article__footer-author"
         v-if="post.author()">Автор: <span itemprop="name">{{ post.author() }}</span></p>
      <p class="tes-article__footer-source"
         v-if="post.source()">Источник: <span>{{ post.source() }}</span></p>
      <link itemprop="url" href="https://tion.ru/">
    </div>

    <ItemPropPublisherDefaultView/>

  </article>

</template>

<script lang="ts">
import {PostInterface} from '../../objects/post/Post'
import {
  addEventListenerLazyPicture,
  fireLazyElement,
  unmountLazyElement
} from '../../objects/LazyImage'

import {onBeforeUnmount, onMounted, onUpdated, PropType, Ref, ref} from 'vue'

import IconView from '../icon/IconView.vue'
import ItemPropPublisherDefaultView from '../include/ItemPropPublisherDefaultView.vue'

import CommentBarsIcon from '~/assets/icons/comment_bars.svg'
import EyeIcon from '~/assets/icons/eye.svg'
import Rating12PlusIcon from '~/assets/icons/age-ratings/12-plus.svg'
//import SmileSmartIcon from '~/assets/icons/smile-smart.svg'

export default {
  name: 'PostView',
  components: {
    IconView,
    ItemPropPublisherDefaultView,
    CommentBarsIcon,
    EyeIcon,
    Rating12PlusIcon,
    //SmileSmartIcon,
  },
  props: {
    post: {
      type: Object as PropType<PostInterface>,
      required: true
    },
  },
  setup() {
    const postContentEl: Ref<HTMLElement | null> = ref<HTMLElement | null>(null)

    onMounted(() => {
      let pictures: NodeListOf<HTMLElement> = document.querySelectorAll('picture[data-preprocessed="true"]')
      Array.from(pictures).forEach(picture => {
        addEventListenerLazyPicture(picture)
        fireLazyElement(picture)
      })
    })

    onUpdated( () => {
      let pictures: NodeListOf<HTMLElement> = document.querySelectorAll('picture[data-preprocessed="true"]')
      Array.from(pictures).forEach(picture => {
        addEventListenerLazyPicture(picture)
        fireLazyElement(picture)
      })
    })

    onBeforeUnmount(() => {
      if (postContentEl.value) {
        let pictures: NodeListOf<HTMLElement> = postContentEl.value.querySelectorAll('picture[data-preprocessed="true"]')
        Array.from(pictures).forEach(picture => {
          unmountLazyElement(picture)
        })
      }
    });

    return {postContentEl}
  }
}
</script>
